module.exports = __webpack_public_path__ + "media/src/admin/images/icon-logo-17b6714429c6b404a46a93fcf978e532.png";